import styled from 'styled-components';

import {sanitizeEmailHtml} from '@dms/shared';

interface MessageDialogProps {
  message: string;
}

export function MessageDialog(props: MessageDialogProps) {
  return (
    // eslint-disable-next-line eslint-js/no-restricted-syntax, react/no-danger -- Sanitized by backend, returned only by BE
    <MessageText dangerouslySetInnerHTML={{__html: sanitizeEmailHtml(props.message)}} />
  );
}

// eslint-disable-next-line eag/no-css-property
const MessageText = styled.div`
  font-size: ${({theme}) => theme.fontSizes.text.xSmall};

  table {
    border-collapse: unset;

    a {
      display: flex;
      width: max-content;
      justify-content: center;
    }
  }
`;
